import backofficeService from '@/api/backoffice.js'
export default {
  getall(params) {
    return backofficeService.Api().get('screen', {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  create(data) {
    return backofficeService.Api().post('screen', data)
      .then(response => {
        console.log('response', response)
        return response.data
      })
      .catch((error) => {
        throw error
      })
  },
  /**
   * Update specific category
   * @param {*} id
   * @param {*} data
   */
  update(id, data) {
    return backofficeService.Api().put(`screen/${id}`, data)
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
  /**
   * Delete ad
   * @param {} id
   * @param {*} params
   */
  delete(id, params) {
    return backofficeService.Api().delete(`screen/${id}`, {
        params
      })
      .then(response => response.data)
      .catch((error) => {
        throw error
      })
  },
}